<button
	*ngIf="!asLabel"
	tlkButton
	type="button"
	size="m"
	variant="secondary"
	[attr.data-testid]="'art-indication-' + indicationClass"
	[class]="['rx-intuitive-art-indication-button', indicationClass]"
	[class.rx-intuitive-art-indication-button--active]="isActive"
	[class.rx-intuitive-art-indication-button--active-disabled]="isActive && disabled"
	[disabled]="disabled"
	(click)="onClicked()"
>
	<span *ngIf="!hideIcon" class="rx-intuitive-art-indication-button__icon"></span>
	<span class="rx-intuitive-art-indication-button__label">{{ indication | artTreatmentTranslate }}</span>
</button>
<div
	*ngIf="asLabel"
	[class]="['rx-intuitive-art-indication-button', 'rx-intuitive-art-indication-button--label', indicationClass]"
	[class.rx-intuitive-art-indication-button--active]="isActive"
>
	<span class="rx-intuitive-art-indication-button__icon"></span>
	<span class="rx-intuitive-art-indication-button__label">{{ indication | artTreatmentTranslate }}</span>
</div>
